import React, {useEffect, useState} from 'react';
import PageHeader1 from '../../components/common/PageHeader1';
import ActiveStatus from "../../components/Form/activeStatus";
import {useNavigate, useParams} from "react-router-dom";
import apiClient from "../../utils/api";
import { mockBrands } from '../../components/Data/MockData';

function BrandEdit() {
    const navigate = useNavigate();
    const {id} = useParams();
    const [formData, setFormData] = useState({
        name: '', is_active: "1",
    });

    useEffect(() => {
        fetchBrand();
    }, [id]);

    const fetchBrand = async () => {
        try {
            const token = localStorage.getItem('auth_token');
            const response = await apiClient.get(`accounts/brands/${id}`,{
                headers: { Authorization: `Bearer ${token}` }
            });
            setFormData({
                ...response.data.data,
                is_active: response.data.data.is_active ? "1" : "0"
            });
        } catch (error) {
            console.error('Error:', error);
        }
    };

    const handleInputChange = (e) => {
        const {name, type, value, checked} = e.target;
        setFormData({...formData, [name]: type === 'checkbox' ? checked : value});
    }

    const onSubmit = async (e) => {
        e.preventDefault();
        const data = new FormData();
        data.append('name', formData.name);
        data.append('is_active', formData.is_active);
        data.append('_method', 'PUT');

        try {
            const token = localStorage.getItem('auth_token');
            await apiClient.post(`accounts/brands/${id}`, data,{
                headers: { Authorization: `Bearer ${token}` }
            });
            navigate(process.env.PUBLIC_URL + '/accounts/brands-list');
        } catch (error) {
            //toast.error('Error updating brand');
        }
    }

    return (<div className="container-xxl">
        <form onSubmit={onSubmit}>
            <PageHeader1 pagetitle='Brand Edit' button={true}/>
            <div className="row g-3">
                <div className="col-xl-4 col-lg-4">
                    <div className="sticky-lg-top">
                        <div className="card mb-3">
                            <ActiveStatus
                                onStatusChange={handleInputChange}
                                checked={formData.is_active}
                                name="is_active"
                            />
                        </div>
                    </div>
                </div>
                <div className="col-xl-8 col-lg-8">
                    <div className="card mb-3">
                        <div className="card-header py-3 d-flex justify-content-between bg-transparent border-bottom-0">
                            <h6 className="mb-0 fw-bold ">Basic information</h6>
                        </div>
                        <div className="card-body">
                            <form>
                                <div className="row g-3 align-items-center">
                                    <div className="col-md-12">
                                        <label className="form-label">Brand Name</label>
                                        <input
                                            type="text"
                                            name="name"
                                            className="form-control"
                                            value={formData.name}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>)
}

export default BrandEdit;